import { inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from '@athena/util';

export abstract class BaseApiService {
  readonly #http = inject(HttpClient);
  readonly #environment = inject(ENVIRONMENT);
  readonly #apiUrl = `${this.#environment.apiUrl}/api`;

  protected post<T>(endpoint: string, body?: unknown): Observable<T> {
    return this.#http.post<T>(`${this.#apiUrl}${endpoint}`, body);
  }

  protected patch<T>(endpoint: string, body: unknown): Observable<T> {
    return this.#http.patch<T>(`${this.#apiUrl}${endpoint}`, body);
  }

  protected get<T>(endpoint: string, headers?: HttpHeaders): Observable<T> {
    return this.#http.get<T>(`${this.#apiUrl}${endpoint}`, { headers });
  }

  protected put<T>(endpoint: string, body: unknown): Observable<T> {
    return this.#http.put<T>(`${this.#apiUrl}${endpoint}`, body);
  }

  protected delete<T>(endpoint: string): Observable<T> {
    return this.#http.delete<T>(`${this.#apiUrl}${endpoint}`);
  }
}
